import type { GlobalSearchResultItem } from 'models';
import { can } from 'old/utils/permissions';
import { useTranslation } from 'react-i18next';

import { isProgramAdminProfile, isProgramAuthorProfile } from 'permissions';
import { Avatar } from 'ui';
import { images } from 'common/utils';
import { useUser } from 'features/auth';
import { SearchItemContent } from '../search-item-content';
import { SearchItemRow } from '../search-item-row';

type P = {
  itemActionProps?: Record<string, unknown>;
  itemProps: GlobalSearchResultItem;
};

const CurriculumItem = ({ itemActionProps, itemProps }: P) => {
  const { t } = useTranslation();
  const { railsUserData: viewer } = useUser();

  const joined = can(itemProps, 'Program', 'isMemberOfProgram') ? t('Joined') : t('Not Joined');
  const admin = isProgramAdminProfile({ programId: itemProps.id, viewer }) ? `, ${t('Admin')}` : '';
  const author = isProgramAuthorProfile({ programId: itemProps.id, viewer }) ? `, ${t('Author')}` : '';

  return (
    <SearchItemRow
      icon={<Avatar alt={itemProps.name} photo={itemProps.coverPhoto ?? images.default.programCoverPhoto} />}
      itemActionProps={itemActionProps}
    >
      <SearchItemContent subtitle={`${joined}${admin}${author}`} title={itemProps.name ?? ''} />
    </SearchItemRow>
  );
};

export default CurriculumItem;
